import Swiper from "swiper";
import { Navigation } from "swiper/modules";

function gallery() {
	const imageSliders = document.querySelectorAll(
		'[data-name="gallery-swiper"]'
	);

	if (imageSliders.length > 0) {
		// Starting point
		imageSliders.forEach((imageSlider) => {
			let slidesPerView1440 = 2;
			let slidesPerView728 = 2.1;
			let slidesPerView = 1.1;
			if (imageSlider.dataset.slides == 1) {
				slidesPerView1440 = 1;
				slidesPerView728 = 1;
				slidesPerView = 1;
			}
			function initializeSwiper() {
				let swiper = new Swiper(imageSlider, {
					modules: [Navigation],
					loop: false,
					loopAddBlankSlides: true,
					loopAdditionalSlides: 2,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					centeredSlides: true,
					slidesPerView: slidesPerView,
					spaceBetween: 15,
					speed: 1000,
					breakpoints: {
						728: {
							slidesPerView: slidesPerView728,
							spaceBetween: 50,
						},
						1440: {
							slidesPerView: slidesPerView1440,
							spaceBetween: 50,
						},
					},
				});
			}
			initializeSwiper();

			// Also re-initialize when the window is resized
			window.addEventListener("resize", initializeSwiper);
		});
	}
}

export default gallery;
